import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-label transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-10 gap-2 md:gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-label text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}